import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './i18n/index.js'
import { initializeGoogleAnalytics } from './lib/googleAnalytics.js'
import App from './App.jsx'
import './styles.css'
import './mobile.css'

initializeGoogleAnalytics()

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
